export default __webpack_public_path__ + "static/media/menu.79681e1f.svg";